import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SharedService } from '../../shared/shared.service';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AbstractControl } from '@angular/forms';
import { GlobalVariable } from '../../shared/global';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';
import { LoggerService } from 'app/logger/logger.service';

const MOBILE_REGEX = /^\d{10}$/;
// tslint:disable-next-line:max-line-length
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.css']
})
export class RewardsComponent implements OnInit {

  passwordFormControl = new FormControl('', [Validators.required]);
  usernameFormControl = new FormControl('', [Validators.required]);

  sign_in_valid: boolean;
  public mobile: string;
  public password: string;
  public keep_me_signed_in: boolean;
  public sign_in_type: string;
  public sign_in_data: Object;
  public component_load: boolean;
  public is_account_setting: boolean;
  public is_internal_user: boolean;
  public userNameForm;
  public username: any;
  public readonly_cls: string;
  public signin_text: any;

  constructor(private meta: Meta, private title:Title, private fb: FormBuilder, private activatedRoute: ActivatedRoute,
    private sharedService: SharedService, private authService: AuthService,private logger:LoggerService,
    private router: Router, private localStorageService: LocalStorageService) {

    this.addUpdateMetaTags();

    this.userNameForm = fb.group({mobilePhoneFormControl: ['', Validators.required]}, { validator: UserNameValidation.UserNameValidate});
    this.sharedService.setHeaderTitle('default_page');
    this.readonly_cls = '';
    this.signin_text = 'Sign In';
    if (this.localStorageService.get('token') != null) {
	  	this.sharedService.setLoader('rewards', true);
      this.component_load = false;
      let methodName = this.constructor.name+'.verifyToken';
        this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
        .then(res => {
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
            if (res.status === 'success'  && res.isTerminated === false) {
            	const person = res.results[0]['personal'][0];
            	this.getRewardDetail(person);

              var dataLayerEvent = 'sign in';
            	(window as any).dataLayer.push({'event': dataLayerEvent,'accountID': person.id.toString()});
            } else {
            	this.localStorageService.remove('token');
            	this.localStorageService.remove('tempToken');
              	this.router.navigate(['./rewards']);
            }
          }, (error)=>{
            let logObj = {
              method: methodName,
              request: "token : [masked]",
              exception: error
            };
            this.logger.logError(JSON.stringify(logObj));
          }).catch((ex)=>{
            let logObj = {
              method: methodName,
              request: "token : [masked]",
              exception: ex
            };
            this.logger.logError(JSON.stringify(logObj));
          });

    } else {
    	this.sharedService.setLoader('rewards', false);
  		this.component_load = true;
    }
  }

  addUpdateMetaTags(){
    this.title.setTitle('My Account | Pogo Energy');
    const titleTag = this.meta.getTag('name=title');

    if (titleTag != undefined) {
      this.meta.updateTag({ name: 'title', content: 'My Account | Pogo Energy'});
    } else {
      this.meta.addTag({ name: 'title', content: 'My Account | Pogo Energy'});
    }

    const descriptionTag = this.meta.getTag('name=description');

    if (descriptionTag != undefined) {
      this.meta.updateTag({ name: 'description', content: 'Sign in to your Pogo Energy account to view history, recharge and manage your contact info.'});
    } else {
      this.meta.addTag({ name: 'description', content: 'Sign in to your Pogo Energy account to view history, recharge and manage your contact info.'});
    }
  }

  ngOnDestroy(){
    this.title.setTitle('Pogo Energy');
    const titleTag = this.meta.getTag('name=title');

    if (titleTag != undefined) {
      this.meta.updateTag({ name: 'title', content: 'Pogo Energy'});
    }

    const descriptionTag = this.meta.getTag('name=description');

    if (descriptionTag != undefined) {
      this.meta.updateTag({ name: 'description', content: ''});
    }
  }

  signInValidate(sign_in_val: any) {
    if (this.mobile !== '' && this.mobile !== undefined &&  (this.mobile.match(MOBILE_REGEX) ||
    	this.mobile.match(EMAIL_REGEX))  && this.password !== undefined && this.password !== '' && this.password.length > 5 ) {
        this.sign_in_valid = true;
        if (sign_in_val.keyCode === 13) {
          document.getElementById('sign_in_btn').click();
        }
    } else {
        this.sign_in_valid = false;
    }
  }

  signIn() {
    this.signin_text = 'Sign In...';
    this.sign_in_valid = false;
    this.sharedService.setHeaderErrorMessage('rewards', false, 'notification error', '');
    this.sign_in_data = {
                'username' : this.mobile,
                'password' : this.password,
                'keep_me_signed_in': this.keep_me_signed_in,
                'isAmberUILogin':true
            };
    this.authService.signIn(this.sign_in_data).then(res => {
        if (res.status === 'success') {
          this.localStorageService.set('token', res.token);
          this.getRewardDetail(res['results'][0]['personal'][0]);
        } else if (res.status === 'fail') {
          this.signin_text = 'Sign In';
          this.sign_in_valid = true;
          window.scrollTo(0, 0);
          this.sharedService.setHeaderErrorMessage('rewards', true, 'notification error', res.message);
        }
    });
  }

  ngOnInit() {
      const len = document.getElementsByTagName('body')[0];
      if (len !== undefined) {
          if (len.classList.contains('body_autocomplete')) {
            len.classList.remove('body_autocomplete');
          }
      }
  }

  enrollForReward(person_details:any){
    this.sharedService.getUserConfig('reward_amount')
      .then(res=>{
        if (res !== undefined && res.result.status === "success") {
          let conf_data = res.result.config[0];
          this.sharedService.enrollToRewardProgram(person_details, conf_data.value)
            .then(res=>{
              if (res != undefined && res.result == "success") {
                this.getRewardDetail(person_details['accountNumber']);
              }
            });
        }
      });
  }

  getRewardDetail(person_details:any){
    let requestObj = {
      "method": "get_token",
      "customer_id": person_details['accountNumber'],
      "key": GlobalVariable.rewardsApiKey
    };

    this.sharedService.rewardAPICall(requestObj)
      .then(res=>{
        if (res != undefined && res.result == "success") {
          window.open( GlobalVariable.rewardsUrl + "login/login_by_stream/"+res.token,"_self");
        } else {
          this.enrollForReward(person_details);
        }
      });
  }

}

export class UserNameValidation {

    static UserNameValidate(AC: AbstractControl) {
       const username = AC.get('mobilePhoneFormControl').value; // to get value in input tag
           if (username !== '' && !username.match(MOBILE_REGEX) && !username.match(EMAIL_REGEX)) {
            AC.get('mobilePhoneFormControl').setErrors( {UserNameValidate: true} )
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/rewards/rewards.component.ts